export default {"src":"/_next/static/media/fb-grey.b679269b.svg","height":32,"width":32};